import { Marker } from '@react-google-maps/api';
import { setIndexActiveEvent } from 'modules/monitorHistory/redux';
import { dataTracksSelector, eventsSelector, indexActiveEventSelector } from 'modules/monitorHistory/selector';
import { useDispatch, useSelector } from 'react-redux';
import PointStart from 'assets/imgs/PointStart.svg';
import PointEnd from 'assets/imgs/PointEnd.svg';
import { EventItem } from 'modules/monitorHistory/type';
import { eventIcon } from 'modules/mapMonitor/constant';
import ModalEvent from './ModalEvent';
import Polyline from './Polyline';

const PolylineMap = (props: any) => {
  const dispatch = useDispatch();

  const tracks = useSelector(dataTracksSelector);
  const events: EventItem[] = useSelector(eventsSelector);
  const indexActiveEvent: number = useSelector(indexActiveEventSelector);

  const handleClickEvent = (indexActive: number) => {
    dispatch(setIndexActiveEvent(indexActive));
  };

  return (
    <>
      {tracks.length && (
        <>
          <Marker
            icon={{
              url: PointStart,
              scaledSize: new google.maps.Size(50, 50),
              origin: new google.maps.Point(0, 0), // origin
              anchor: new google.maps.Point(24, 18),
            }}
            position={{
              lat: tracks[0].lat,
              lng: tracks[0].lng,
            }}
          />
          <Marker
            icon={{
              url: PointEnd,
              scaledSize: new google.maps.Size(50, 50),
              origin: new google.maps.Point(0, 0), // origin
              anchor: new google.maps.Point(24, 18),
            }}
            position={{
              lat: tracks[tracks.length - 1].lat,
              lng: tracks[tracks.length - 1].lng,
            }}
          />
          <Polyline />
        </>
      )}

      {events?.map((value: EventItem, index: number) => {
        return (
          <Marker
            icon={eventIcon}
            position={{
              lat: value.gpsSeq?.coordinate[1],
              lng: value.gpsSeq?.coordinate[0],
            }}
            key={index}
            onClick={() => handleClickEvent(index)}
          >
            {index === indexActiveEvent && <ModalEvent event={value} />}
          </Marker>
        );
      })}
    </>
  );
};

export default PolylineMap;
